import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { isEnded } from '../../../utility/isEnded';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const TherapyDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedArr = documents.toSorted(sortDocumentsDescending);
  const activeTherapies = sortedArr.filter(d => !isEnded(d.endDate));
  const endedTherapies = sortedArr.filter(d => isEnded(d.endDate));

  const { formatMessage } = useIntl();

  const therapyTitle = (ther: ITherapy) => {
    if (ther.otherTherapyType) return ther.otherTherapyType;
    if (ther.therapyTypes) return <FormattedMessage id={`therapy.opts.${ther.therapyTypes}`} />;
    if (ther.therapyClassification)
      return <FormattedMessage id={`therapy.therapyClassification.opts.${ther.therapyClassification}`} />;
    return '';
  };

  return (
    <TileContentMaker
      type="listWithSubheaders"
      data={{
        nokey: {
          data: activeTherapies.map(a => ({
            date: isPartialDate(a.date) ? formatPartialDate(a.date) : '',
            title: therapyTitle(a),
            key: a._id,
          })),
          type: 'recentList',
        },
        [formatMessage({ id: 'therapy.inActiveTherapies' })]: {
          data: endedTherapies.map(a => ({
            date: isPartialDate(a.date) ? formatPartialDate(a.date) : '',
            title: therapyTitle(a),
            endDate: isPartialDate(a.endDate) ? formatPartialDate(a.endDate) : null,
            key: a._id,
          })),
          type: 'recentList',
        },
      }}
    />
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'therapy'>[];
}

export default TherapyDash;
